import { BaseDto } from "@/shared/dtos/base-dto";

export class preguntas extends BaseDto {
  public nombre!: string;
  public modo_libre!: boolean;
  public id_dashboard!: number;
  public map_field_object!: number;
}
